import "./wholesalers.css"
import { FaMobileAlt, FaBell, FaStream } from "react-icons/fa";
import { FaFileAlt, FaCertificate, FaStore } from "react-icons/fa";
import { FaCloudDownloadAlt, FaLock, FaClipboardCheck, FaHistory } from "react-icons/fa";
import ResponsiveContainer from "./../../../responsive/components/ResponsiveContainer/ResponsiveContainer"

const Wholesalers = () => {
    const inventoryFeatures = [
        {
            title: "Real-Time Scanning",
            desc: "Instantly verify authenticity and quality with our mobile scanning technology",
            icon: <FaMobileAlt />, // Mobile phone = scanning
        },
        {
            title: "Automated Alerts",
            desc: "Get immediate notifications for any discrepancies or issues with incoming inventory",
            icon: <FaBell />, // Bell = alerts/notifications
        },
        {
            title: "Chain of Custody",
            desc: "Complete tracking from manufacturer to your warehouse with detailed audit trails",
            icon: <FaStream />, // Stream = connected flow/chain
        },
    ];

    const buildTrustFeatures = [
        {
            title: "Transparency Reports",
            desc: "Share detailed product history and verification status with your retail partners",
            icon: <FaFileAlt />, // Document/report
        },
        {
            title: "Quality Assurance",
            desc: "Demonstrate your commitment to quality with verified authenticity certificates",
            icon: <FaCertificate />, // Certificate icon
        },
        {
            title: "Partner Portal",
            desc: "Give retailers access to real-time inventory status and product information",
            icon: <FaStore />, // Store/retail icon
        },
    ];

    const certificateFeatures = [
        {
            title: "Instant Access",
            desc: "Download certificates immediately upon product verification",
            icon: <FaCloudDownloadAlt />,
        },
        {
            title: "Blockchain Security",
            desc: "Tamper-proof certificates secured by advanced blockchain technology",
            icon: <FaLock />,
        },
        {
            title: "Compliance Ready",
            desc: "Automatically formatted for regulatory requirements and audits",
            icon: <FaClipboardCheck />,
        },
        {
            title: "Audit Trail",
            desc: "Maintain a complete history of certificate issuance and verification",
            icon: <FaHistory />, // History = trail/log
        },
    ];

    return (
        <ResponsiveContainer>
            <div className="wholesalers-page ">
                <div className="wholesalers-header">
                    <h1 className="wholesalers-title">For Wholesalers</h1>
                </div>

                <section className="wholesalers-section instant-verify">
                    <h2>Instantly Verify Incoming Shipments</h2>
                    <p>
                        Eliminate delays and reduce risk with real-time shipment verification. Our advanced technology ensures every incoming product meets your standards before it reaches your warehouse floor.
                    </p>

                    <div className="features">
                        {
                            inventoryFeatures.map((feature, index) => (
                                <div key={index} className="feature-inventory">
                                    <div className="icon">
                                        {feature.icon}
                                    </div>
                                    <h3>
                                        {feature.title}
                                    </h3>
                                    <p>{feature.desc}</p>
                                </div>
                            ))
                        }
                    </div>
                </section>

                <section className="wholesalers-section build-trust">
                    <h2>Build Trust with Your Retailers</h2>
                    <p>Strengthen relationships and increase retailer confidence with complete transparency. Provide your retail partners with the verification and documentation they need to trust your products.</p>
                    <div className="content-build-trust">
                        <div className="features-build-trust">
                            {
                                buildTrustFeatures.map((feature, index) => (
                                    <div key={index} className="feature-build-trust">
                                        <div className="icon">
                                            {feature.icon}
                                        </div>
                                        <div className="text">
                                            <h3>{feature.title}</h3>
                                            <p>{feature.desc}</p>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="build-trust-image">

                        </div>
                    </div>
                </section>

                <section className="wholesalers-section access-certificates">
                    <h2>Access Digital Certificates</h2>
                    <p>Streamline compliance and reduce paperwork with instant access to digital certificates. Every product comes with blockchain-secured documentation that proves authenticity and compliance.</p>
                    <div className=" features-access-certificates">
                        {
                            certificateFeatures.map((feature, index) => (
                                <div key={index} className="feature-access-certificates">
                                    <div className="icon">
                                        {feature.icon}
                                    </div>
                                    <h3>
                                        {feature.title}
                                    </h3>
                                    <p>{feature.desc}</p>
                                </div>
                            ))
                        }
                    </div>
                </section>
            </div>
        </ResponsiveContainer>
    )
}

export default Wholesalers
